// 奈瑞儿
// 体质报告等等
const natvip = (r) => require.ensure([], () => r(require('../views/natvip/index.vue')), 'natvip');

const meridianwhole = (r) => require.ensure([], () => r(require('../views/natvip/meridianwhole.vue')), 'meridianwhole');

// 皮测报告-首页
const skinReport = (r) => require.ensure([], () => r(require('../views/natvip/skinReport.vue')), 'skinReport');

// 皮测报告-二级页面检测分析
const skinDetail = (r) => require.ensure([], () => r(require('../views/natvip/skinDetail.vue')), 'skinDetail');

// 皮测报告-肤质、肤色、肤龄图片检测分析
const skinImgDetail = (r) => require.ensure([], () => r(require('../views/natvip/skinImgDetail.vue')), 'skinImgDetail');

// 皮测报告-雷达图检测分析
const skinRadar = (r) => require.ensure([], () => r(require('../views/natvip/skinRadar.vue')), 'skinRadar');

// 问卷好评
const questionnaireEvalution = (r) =>
  require.ensure([], () => r(require('../views/questionnaireEvalution/index.vue')), 'questionnaireEvalution');

const meridianwholeNew = (r) =>
  require.ensure([], () => r(require('../views/natvip/meridianwholeNew.vue')), 'meridianwholeNew');

const meridianVein = (r) => require.ensure([], () => r(require('../views/natvip/meridianVein.vue')), 'meridianVein');

const meridinProject = (r) =>
  require.ensure([], () => r(require('../views/natvip/meridianProject.vue')), 'meridinProject');

const meridianCompare = (r) =>
  require.ensure([], () => r(require('../views/natvip/meridianCompare.vue')), 'meridianCompare');

// 健康云图报告2.0
const aiInfraredReport = (r) =>
  require.ensure([], () => r(require('../views/natvip/aiInfraredReport.vue')), 'aiInfraredReport');

// 健康云图报告-更多建议
const moreSuggestions = (r) =>
  require.ensure([], () => r(require('../views/natvip/moreSuggestions.vue')), 'moreSuggestions');

// ========================== 历史报告目标跳转路由 Start ==========================
// 体质报告等等
const natvipHistory = (r) => require.ensure([], () => r(require('../views/natvip/index.vue')), 'natvip');

// 经络报告2.0
const meridianVeinHistory = (r) =>
  require.ensure([], () => r(require('../views/natvip/meridianVein.vue')), 'meridianVein');

// 健康云图报告2.0
const aiInfraredReportHistory = (r) =>
  require.ensure([], () => r(require('../views/natvip/aiInfraredReport.vue')), 'aiInfraredReport');
// ========================== 历史报告目标跳转路由 End ==========================

// ========================== 女性特护1.0 跳转路由 Start ==========================
// 私密报告
const privacyReport = (r) => require.ensure([], () => r(require('../views/natvip/privacyReport.vue')), 'privacyReport');

// 私密平衡态
const privacyReportImage = (r) =>
  require.ensure([], () => r(require('../views/natvip/privacyReportImage.vue')), 'privacyReportImage');

// 雷达图详情
const privacyReportRadarDetail = (r) =>
  require.ensure([], () => r(require('../views/natvip/privacyReportRadarDetail.vue')), 'privacyReportRadarDetail');
// ========================== 女性特护1.0 跳转路由 Start ==========================

// 疼痛量表报告
const PainReport = (r) => require.ensure([], () => r(require('../views/natvip/painReport.vue')), 'PainReport');

// 评价
const evaluateSuccess = (r) =>
  require.ensure([], () => r(require('../views/evaluateSuccess/index.vue')), 'evaluateSuccess');

const routes = [
  {
    path: '/natvip',
    name: 'natvip',
    component: natvip,
    meta: {
      title: '报告详情',
      keepAlive: true,
    },
  },
  {
    path: '/meridianwhole',
    name: 'meridianwhole',
    component: meridianwhole,
    meta: {
      title: '经络完整数据',
    },
  },
  {
    path: '/skinReport',
    name: 'skinReport',
    component: skinReport,
    meta: {
      title: '全肤智测报告',
    },
  },
  {
    path: '/skinDetail',
    name: 'skinDetail',
    component: skinDetail,
    meta: {
      title: '详细分析',
    },
  },
  {
    path: '/skinImgDetail',
    name: 'skinImgDetail',
    component: skinImgDetail,
    meta: {
      title: '图片检测分析',
    },
  },
  {
    path: '/skinRadar',
    name: 'skinRadar',
    component: skinRadar,
    meta: {
      title: '雷达图检测分析',
      keepAlive: true,
    },
  },
  {
    path: '/questionnaireEvalution',
    name: 'questionnaireEvalution',
    component: questionnaireEvalution,
    meta: {
      title: '评价成功',
    },
  },
  {
    path: '/evaluateSuccess',
    name: 'evaluateSuccess',
    component: evaluateSuccess,
    meta: {
      title: '评价',
    },
  },
  {
    path: '/meridianwholeNew',
    name: 'meridianwholeNew',
    component: meridianwholeNew,
    meta: {
      title: '经络报告',
      keepAlive: true,
    },
  },
  {
    path: '/veinReport',
    name: 'meridianVein',
    component: meridianVein,
    meta: {
      title: '经络报告',
      keepAlive: true,
    },
  },
  {
    path: '/meridianProject',
    name: 'meridianProject',
    component: meridinProject,
    meta: {
      title: '经络历年项目',
    },
  },
  {
    path: '/meridianCompare',
    name: 'meridianCompare',
    component: meridianCompare,
    meta: {
      title: '经络对比报告',
    },
  },
  {
    path: '/aiInfraredReport',
    name: 'aiInfraredReport',
    component: aiInfraredReport,
    meta: {
      title: '健康云图报告',
      keepAlive: true,
    },
  },
  {
    path: '/moreSuggestions',
    name: 'moreSuggestions',
    component: moreSuggestions,
    meta: {
      title: '更多建议',
    },
  },
];

// 单独用于历史报告的跳转
const historyReportRoutes = [
  {
    path: '/natvipHistory',
    name: 'natvipHistory',
    component: natvipHistory,
    meta: {
      title: '报告详情',
      // 历史报告：每次进入（含 query 变化）都强制重新挂载页面
      forceReload: true,
    },
  },
  {
    path: '/meridianVeinHistory',
    name: 'meridianVeinHistory',
    component: meridianVeinHistory,
    meta: {
      title: '经络报告',
      forceReload: true,
    },
  },
  {
    path: '/aiInfraredReportHistory',
    name: 'aiInfraredReportHistory',
    component: aiInfraredReportHistory,
    meta: {
      title: '健康云图报告',
      forceReload: true,
    },
  },
  {
    path: '/privacyReport',
    name: 'privacyReport',
    component: privacyReport,
    meta: {
      title: '私密报告',
      forceReload: true,
    },
  },
  {
    path: '/privacyReportImage',
    name: 'privacyReportImage',
    component: privacyReportImage,
    meta: {
      title: '私密平衡态',
      forceReload: true,
    },
  },
  {
    path: '/privacyReportRadarDetail',
    name: 'privacyReportRadarDetail',
    component: privacyReportRadarDetail,
    meta: {
      title: '雷达图详情',
      forceReload: true,
    },
  },
  {
    path: '/painReport',
    name: 'PainReport',
    component: PainReport,
    meta: {
      title: '疼痛报告',
      forceReload: true,
    },
  },
];

export default [...routes, ...historyReportRoutes];



// WEBPACK FOOTER //
// ./src/router/natvip.js